<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="create-third-party-costs-modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <form @submit.prevent="submit">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
                        </button>

                        <h4 class="modal-title">
                            Create Third Party Costs
                        </h4>
                    </div>

                    <div class="modal-body">
                        <number-form-group
                                v-model="thirdPartyCosts.amount"
                                name="amount"
                                label="Amount"
                                :error="getError('amount')"
                                help-text="The amount to pay as third party costs."
                        ></number-form-group>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            Close
                        </button>

                        <button type="submit" class="btn btn-black">
                            <i class="fa fa-save"></i> Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import notify from '@/notify'
    import Errors from '@/mixins/Errors'
    import NumberFormGroup from '@/vendor/forms/FormGroups/Block/Number'

    export default {
        components: {NumberFormGroup},

        mixins: [Errors],

        props: ['ads'],

        data() {
            return {
                thirdPartyCosts: {}
            }
        },

        mounted() {
            this.listenForClose()
        },

        methods: {
            listenForClose() {
                $(this.$el).on('hidden.bs.modal', this.reset)
            },

            submit() {
                http.post('/api/v1/third-party-costs', {ads: this.ads, ...this.thirdPartyCosts})
                    .then(() => {
                        notify.success('The third party costs were saved')

                        this.$emit('created')

                        $(this.$el).modal('hide')
                    })
                    .catch(this.catchValidationErrors)
            },

            reset() {
                this.errors = {}

                this.thirdPartyCosts = {}
            }
        }
    }
</script>
